const smoothEase = [0.22, 1, 0.36, 1];

export const commonUpAppearVariants = {
  closed: { opacity: 0, y: 36 },
  open: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.65, ease: smoothEase },
  },
};

export const commonDownAppearVariants = {
  closed: { opacity: 0, y: -24 },
  open: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease: smoothEase },
  },
};

export const commonOpacityAppearVariants = {
  closed: { opacity: 0 },
  open: { opacity: 1, transition: { duration: 0.6, ease: smoothEase } },
};

export const parentVariants = {
  closed: { opacity: 0 },
  open: {
    opacity: 1,
    transition: { staggerChildren: 0.08, delayChildren: 0.05 },
  },
};

export const sidebarVariants = {
  open: {
    x: "0%",
    opacity: 1,
    transition: {
      x: { duration: 0.38, ease: smoothEase },
      opacity: { duration: 0.2, ease: "easeOut" },
    },
  },
  closed: {
    x: "100%",
    opacity: 0.98,
    transition: {
      x: { duration: 0.3, ease: [0.4, 0, 1, 1] },
      opacity: { duration: 0.18, ease: "easeIn" },
    },
  },
};

export const navigationVariants = {
  open: {
    transition: { staggerChildren: 0.06, delayChildren: 0.12 },
  },
  closed: {
    transition: { staggerChildren: 0.035, staggerDirection: -1 },
  },
};

export const navigationItemVariants = {
  open: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.3, ease: smoothEase },
  },
  closed: {
    opacity: 0,
    x: 18,
    transition: { duration: 0.2, ease: smoothEase },
  },
};
